import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=4b7354e9&scoped=true&"
import script from "./Resumo.vue?vue&type=script&lang=js&"
export * from "./Resumo.vue?vue&type=script&lang=js&"
import style0 from "./Resumo.vue?vue&type=style&index=0&id=4b7354e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7354e9",
  null
  
)

export default component.exports